module.exports = __webpack_public_path__ + "static/img/icon1-8.acc86189.png";